import { useAuthStore } from '@/stores/authStore'
import { Button } from '@/components/ui/button'
import { AlertTriangle } from 'lucide-react'

export const ImpersonationBanner = () => {
  const { impersonating, user, stopImpersonation, originalToken } = useAuthStore()

  if (!impersonating) return null

  const handleStop = () => {
    stopImpersonation()
    if (originalToken) {
      localStorage.setItem('auth_token', originalToken)
    }
    window.location.href = '/dashboard'
  }

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between text-sm">
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4" />
        <span>
          Impersonating: {user?.firstName} {user?.lastName} ({user?.email})
        </span>
      </div>
      <Button size="sm" variant="secondary" onClick={handleStop}>
        Stop Impersonating
      </Button>
    </div>
  )
}
